<p-dialog [visible]="true" [breakpoints]="{'440px': '100%'}" [style]="{width: '40%'}" [baseZIndex]="10000"
  [modal]="true" [maximizable]="false" [draggable]="false" [resizable]="false"
  [ngClass]="{'change-scrollbar-color-darkMode': settings.darkModeSetting, 'change-scrollbar-color': !settings.darkModeSetting}">
  <dialog-header [title]="app.translations.COL_lbl_Title" [settings]="settings" [icon]="faPen"></dialog-header>
  <div class="row" [ngClass]="settings.darkModeSetting ? 'bg-dark' : 'bg-white'" cdkDropList [cdkDropListData]="headers"
    (cdkDropListDropped)="drop($event)">
    <ng-container *ngFor="let header of headers">
      <div class="col-12 animated fadeIn flex justify-left padding15" cdkDrag>
        <div class="p-field-checkbox">
          <mat-checkbox [checked]="header.visible" (change)="update(header.caption, $event)">
            <span [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">
              {{header.caption}}
            </span>
          </mat-checkbox>
          <div cdkDragHandle [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textGreen'"
            class="drag-handle absolute font17 cursorPointer" style="right: 30px; transform: translateY(-25px);">
            <fa-icon [icon]="faGrip"></fa-icon>
          </div>
        </div>

      </div>
    </ng-container>
  </div>
  <div class="row sticky dialog-footer-container" [ngClass]="settings.darkModeSetting ? 'bg-dark' : 'bg-white'">
    <div class="col-12 unset-p">
      <div class="flex justify-right padding10 dialog-footer">
        <button class="btn font17" (click)="save()">
          <fa-icon [icon]="faFloppyDisk" class="textGreen"></fa-icon>
          <span
            [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">{{app.translations.GBL_btn_SaveText}}</span>
        </button>
      </div>
    </div>
  </div>
</p-dialog>